// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"styles_custom-scroll__Fqspe","form-container":"styles_form-container__KAGGq"};